/* eslint-disable react/prop-types */

import React, { Fragment, useState, Suspense, useEffect } from "react";
import {
  Routes,
  Route,
  Link,
  useNavigate,
} from "react-router-dom";
import Drawer from "@mui/material/Drawer";
import Toolbar from "@mui/material/Toolbar";
import MenuList from "@mui/material/MenuList";
import MenuItem from "@mui/material/MenuItem";
import NavBar from "../../components/NavBar/NavBar";
import Logo from "../../assets/Images/logo.png";
import Typography from "@mui/material/Typography";
import makeStyles from '@mui/styles/makeStyles';
import HomePage from "./Contents/HomePage/HomePage";
import Leaf from "../../assets/Images/svg/leaf.svg";
import Calendar from "./Contents/Calendar/Calendar";
import Attendance from "./Contents/Attendance/Attendance";
import F107Form from "./Contents/Forms/F107Form/F107Form";
import F200Form from "./Contents/Forms/F200Form/F200Form";
import F111Form from "./Contents/Forms/F111Form/F111Form";
import R110Reports from "./Contents/Reports/R110Reports/R110Reports";
import F113Form from "./Contents/Forms/F113Form/F113Form";
import F115Form from "./Contents/Forms/F115Form/F115Form";
import F116Form from "./Contents/Forms/F116Form/StudentCourseSelection";
import R114Reports from "./Contents/Reports/R114Reports/R114Reports";
import GradedDiscussion from "./Contents/GradedDiscussion/GradedDiscussionForm";
import GradedDiscussionReports from "./Contents/GradedDiscussion/GradedDiscussionReports";
import CourseHomePage from "./Contents/CourseHomePage/CourseHomePage";
import TutionFeePayment from "./Contents/Forms/TutionFeePayment/TutionFeePayment";
import F300Form from "./Contents/Forms/F300Form/F300Form";
import R301StudentProgressApprovedReport from "./Contents/Reports/R301Reports/R301StudentProgressApprovedReport";
import F303Form from "./Contents/Forms/F303Form/F303Form";
import R338AttendanceDailyReport from "../Dashboard/Contents/Reports/R338Reports/R338AttendanceDailyReport";

const drawerWidth = 300;

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  menuTitle: {
    backgroundColor: "#103C6E",
    fontFamily: "sans-serif",
    display: "flex",
    cursor: "default",
    fontSize: 16,
    fontWeight: 600,
    padding: 5,
    marginTop: 15,
  },
  menuItemPadding: {
    padding: "0 !important",
    cursor: "pointer",
  },
  menuTitleIcon: {
    height: 25,
    width: 25,
    marginRight: 10,
    marginLeft: 15,
  },
  menuItemText: {
    textAlign: "left",
    paddingTop: 3,
    paddingBottom: 3,
    paddingLeft: 25,
    color: "white",
    width: drawerWidth - 50,
    textOverflow: "clip",
    whiteSpace: "break-spaces",
  },
  active: {
    backgroundColor: "#103C6E",
    paddingTop: 5,
    paddingBottom: 5,
  },
  content: {
    flexGrow: 1,
    padding: theme.spacing(1),
    transition: theme.transitions.create("margin", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  contentShift: {
    transition: theme.transitions.create("margin", {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
    marginLeft: drawerWidth,
  },
  toolbar: theme.mixins.toolbar,
  drawer: {
    width: drawerWidth - 10,
  },
  drawerPaper: {
    width: drawerWidth,
    color: "#F5F5F5",
    backgroundColor: "#174A84",
  },
  drawerContainer: {
    overflow: "auto",
    justifyContent: "space-between",
    display: "flex",
    flexDirection: "column",
    height: "100%",
  },
  regular: {
    minHeight: 0,
  },
  menuListContainer: {
    borderLeft: "3px solid",
  },
}));

const RouteWrapper = ({ name, setValue, children }) => {
  useEffect(() => {
    setValue(name);
  }, [name, setValue]);

  return children;
};

const NoFound = () => {
  const navigate = useNavigate();

  useEffect(() => {
    navigate("/dashboard", { replace: true });
  }, [navigate]);

  return null;
};

const Dashboard = () => {
  const classes = useStyles();
  const [viewValue, setViewValue] = useState("");
  const [isDrawerOpen, setDrawerOpen] = useState(false);
  const lmsData = localStorage.getItem("lmsData")
    ? JSON.parse(localStorage.getItem("lmsData"))
    : {};
  const featureList = [
    {
      typeId: 1,
      typeLabel: "Learning Management System",
      items: [
        {
          id: 1,
          action: "calendar",
          webUrl: "/dashboard/calendar",
          label: "Join Class",
        },
        {
          id: 2,
          action: "attendance",
          webUrl: "/dashboard/attendance",
          label: "Attendance",
        },
        {
          id: 3,
          action: "F107Form",
          webUrl: "/dashboard/F107Form/0",
          label: "Assignements",
        },
        {
          id: 4,
          action: "graded-discussion-reports",
          webUrl: "/dashboard/graded-discussion-reports",
          label: "Graded Discussion Board",
        },
      ],
    },
  ];

  const handleValueChange = (value) => {
    setViewValue(value);
  };

  const setOpenMenu = (e) => {
    e.preventDefault();
    const prevFlag = isDrawerOpen;
    setDrawerOpen(!prevFlag);
  };

  return (
    <Fragment>
      <NavBar
        setOpenMenu={(e) => setOpenMenu(e)}
        isOpenMenu={isDrawerOpen}
        logo={Logo}
        title="University College London"
        isAuthorize
        userName={lmsData.displayName}
        isDisabled={lmsData.feeDueDateStatus === 3}
        // && lmsData.feedBackRequired==1
      />
      <Drawer
        open={isDrawerOpen}
        onClose={() => setDrawerOpen(false)}
        className={classes.drawer}
        variant="persistent"
        anchor="left"
        classes={{
          paper: classes.drawerPaper,
        }}
      >
        <Toolbar />
        <div className={classes.drawerContainer}>
          <div>
            {featureList.map((feature) => {
              const { items = [] } = feature;
              return (
                <div key={feature.typeId} className={classes.menuListContainer}>
                  <Typography className={classes.menuTitle} noWrap variant="h6">
                    <img alt="" className={classes.menuTitleIcon} src={Leaf} />{" "}
                    <div>{feature.typeLabel}</div>
                  </Typography>
                  <MenuList
                    style={{
                      outline: "none",
                    }}
                  >
                    {items.map((option) => {
                      return (
                        <MenuItem
                          key={option.id}
                          className={`${classes.menuItemPadding}`}
                        >
                          <Link
                            style={{ textDecoration: "none" }}
                            to={option.webUrl}
                          >
                            <Typography
                              className={`${classes.menuItemText} ${
                                viewValue === `${option.action}` &&
                                classes.active
                              }`}
                              noWrap
                              variant="body2"
                            >
                              {option.label}
                            </Typography>
                          </Link>
                        </MenuItem>
                      );
                    })}
                  </MenuList>
                </div>
              );
            })}
          </div>
          <div
            style={{
              maxWidth: drawerWidth - 15,
              paddingBottom: 10,
              paddingTop: 20,
            }}
          >
            <Typography
              variant="body2"
              style={{ fontSize: 12, color: "white" }}
              align="center"
            >
              Copyright © {new Date().getFullYear()}. Universal College Lahore
              <br></br>(UCL), Pakistan - All Rights Reserved
            </Typography>
          </div>
        </div>
      </Drawer>
      <main className={`${classes.content} ${isDrawerOpen ? classes.contentShift : ''}`}>
        <div className={classes.toolbar} />
        <Suspense fallback={<p>Loading...</p>}>
          {lmsData.feeDueDateStatus === 3 ? (
            <Routes>
              <Route
                path="*"
                element={
                  <RouteWrapper
                    name="TutionFeePayment"
                    setValue={(value) => handleValueChange(value)}
                  >
                    <TutionFeePayment
                      isDrawerOpen={isDrawerOpen}
                      setDrawerOpen={setDrawerOpen}
                    />
                  </RouteWrapper>
                }
              />
            </Routes>
          ) : (
            <Routes>
              <Route
                path="/dashboard"
                element={
                  <RouteWrapper
                    setValue={(value) => handleValueChange(value)}
                    name="home"
                  >
                    <HomePage />
                  </RouteWrapper>
                }
              />
              <Route
                path="/dashboard/calendar"
                element={
                  <RouteWrapper
                    setValue={(value) => handleValueChange(value)}
                    name="calendar"
                  >
                    <Calendar />
                  </RouteWrapper>
                }
              />
              <Route
                path="/dashboard/attendance"
                element={
                  <RouteWrapper
                    setValue={(value) => handleValueChange(value)}
                    name="attendance"
                  >
                    <Attendance />
                  </RouteWrapper>
                }
              />
              <Route
                path="/dashboard/TutionFeePayment/:id"
                element={
                  <RouteWrapper
                    name="TutionFeePayment"
                    setValue={(value) => handleValueChange(value)}
                  >
                    <TutionFeePayment
                      isDrawerOpen={isDrawerOpen}
                      setDrawerOpen={setDrawerOpen}
                    />
                  </RouteWrapper>
                }
              />
              <Route
                path="/dashboard/F200Form/:id"
                element={
                  <RouteWrapper
                    name="F200Form"
                    setValue={(value) => handleValueChange(value)}
                  >
                    <F200Form
                      isDrawerOpen={isDrawerOpen}
                      setDrawerOpen={setDrawerOpen}
                    />
                  </RouteWrapper>
                }
              />
              <Route
                path="/dashboard/F107Form/:id"
                element={
                  <RouteWrapper
                    name="F107Form"
                    setValue={(value) => handleValueChange(value)}
                  >
                    <F107Form
                      isDrawerOpen={isDrawerOpen}
                      setDrawerOpen={setDrawerOpen}
                    />
                  </RouteWrapper>
                }
              />
              <Route
                path="/dashboard/R110Reports"
                element={
                  <RouteWrapper
                    name="R110Reports"
                    setValue={(value) => handleValueChange(value)}
                  >
                    <R110Reports
                      isDrawerOpen={isDrawerOpen}
                      setDrawerOpen={setDrawerOpen}
                    />
                  </RouteWrapper>
                }
              />
              <Route
                path="/dashboard/F111Form/:id"
                element={
                  <RouteWrapper
                    name="F111Form"
                    setValue={(value) => handleValueChange(value)}
                  >
                    <F111Form
                      isDrawerOpen={isDrawerOpen}
                      setDrawerOpen={setDrawerOpen}
                    />
                  </RouteWrapper>
                }
              />
              <Route
                path="/dashboard/graded-discussion/:gdaId"
                element={
                  <RouteWrapper
                    setValue={(value) => handleValueChange(value)}
                    name="graded-discussion"
                  >
                    <GradedDiscussion
                      isDrawerOpen={isDrawerOpen}
                      setDrawerOpen={setDrawerOpen}
                    />
                  </RouteWrapper>
                }
              />
              <Route
                path="/dashboard/graded-discussion-reports"
                element={
                  <RouteWrapper
                    setValue={(value) => handleValueChange(value)}
                    name="graded-discussion-reports"
                  >
                    <GradedDiscussionReports
                      isDrawerOpen={isDrawerOpen}
                      setDrawerOpen={setDrawerOpen}
                    />
                  </RouteWrapper>
                }
              />
              <Route
                path="/dashboard/R338AttendanceDailyReport"
                element={
                  <RouteWrapper
                    setValue={(value) => handleValueChange(value)}
                    name="R338AttendanceDailyReport"
                  >
                    <R338AttendanceDailyReport
                      isDrawerOpen={isDrawerOpen}
                      setDrawerOpen={setDrawerOpen}
                    />
                  </RouteWrapper>
                }
              />
              <Route
                path="/dashboard/CourseHomePage/:courseId"
                element={
                  <RouteWrapper
                    setValue={(value) => handleValueChange(value)}
                    name="CourseHomePage"
                  >
                    <CourseHomePage
                      isDrawerOpen={isDrawerOpen}
                      setDrawerOpen={setDrawerOpen}
                    />
                  </RouteWrapper>
                }
              />
              <Route
                path="/dashboard/F113Form/:id"
                element={
                  <RouteWrapper
                    name="F113Form"
                    setValue={(value) => handleValueChange(value)}
                  >
                    <F113Form
                      isDrawerOpen={isDrawerOpen}
                      setDrawerOpen={setDrawerOpen}
                    />
                  </RouteWrapper>
                }
              />
              <Route
                path="/dashboard/F115Form/:id"
                element={
                  <RouteWrapper
                    name="F115Form"
                    setValue={(value) => handleValueChange(value)}
                  >
                    <F115Form
                      isDrawerOpen={isDrawerOpen}
                      setDrawerOpen={setDrawerOpen}
                    />
                  </RouteWrapper>
                }
              />
              <Route
                path="/dashboard/F116Form/:id"
                element={
                  <RouteWrapper
                    name="F116Form"
                    setValue={(value) => handleValueChange(value)}
                  >
                    <F116Form
                      isDrawerOpen={isDrawerOpen}
                      setDrawerOpen={setDrawerOpen}
                    />
                  </RouteWrapper>
                }
              />
              <Route
                path="/dashboard/R114Reports"
                element={
                  <RouteWrapper
                    name="R114Reports"
                    setValue={(value) => handleValueChange(value)}
                  >
                    <R114Reports
                      isDrawerOpen={isDrawerOpen}
                      setDrawerOpen={setDrawerOpen}
                    />
                  </RouteWrapper>
                }
              />
              <Route
                path="/dashboard/F300Form/:id"
                element={
                  <RouteWrapper
                    name="F300Form"
                    setValue={(value) => handleValueChange(value)}
                  >
                    <F300Form
                      isDrawerOpen={isDrawerOpen}
                      setDrawerOpen={setDrawerOpen}
                    />
                  </RouteWrapper>
                }
              />
              <Route
                path="/dashboard/R301StudentProgressApprovedReport"
                element={
                  <RouteWrapper
                    name="R301StudentProgressApprovedReport"
                    setValue={(value) => handleValueChange(value)}
                  >
                    <R301StudentProgressApprovedReport
                      isDrawerOpen={isDrawerOpen}
                      setDrawerOpen={setDrawerOpen}
                    />
                  </RouteWrapper>
                }
              />
              <Route
                path="/dashboard/F303Form/:id"
                element={
                  <RouteWrapper
                    name="F303Form"
                    setValue={(value) => handleValueChange(value)}
                  >
                    <F303Form
                      isDrawerOpen={isDrawerOpen}
                      setDrawerOpen={setDrawerOpen}
                    />
                  </RouteWrapper>
                }
              />
              <Route
                path="*"
                element={
                  <RouteWrapper
                    setValue={(value) => handleValueChange(value)}
                    name="home"
                  >
                    <NoFound />
                  </RouteWrapper>
                }
              />
            </Routes>
          )}
        </Suspense>
      </main>
    </Fragment>
  );
};

export default Dashboard;
